import actions from './actions';
import getters from './getters';
import mutations from './mutations';


const getDefaultState = () => ({
  items : [],
  itemsOudated : true,
  allItems : [],
  allItemOutdated : true,
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations,
  getDefaultState,
};
